const selectParams = <T extends object, U extends keyof T>(
  data: T,
  paramKeys: Array<U>,
): Pick<T, U> => {
  return paramKeys.reduce(
    (map, paramKey) => {
      if (!data[paramKey]) return map;

      return {
        ...map,
        [paramKey]: data[paramKey],
      };
    },
    {} as Pick<T, U>,
  );
};

export default selectParams;
